import type { DiscoveredRouteModule } from '@/router/generator/types';

const CalendarInvitationView = () => import('@/views/CalendarInvitationView.vue');

export const NAME_CALENDAR_INVITATION = 'CalendarInvitation';
export const PATH_CALENDAR_INVITATION = '/invitation/:token/:action?';

export const route: DiscoveredRouteModule = {
  id: 'root.calendarInvitation',
  scope: 'root',
  name: NAME_CALENDAR_INVITATION,
  path: PATH_CALENDAR_INVITATION,
  component: CalendarInvitationView,
  meta: {
    requiresAuth: false,
    skipProjectCheck: true,
    skipPermissionCheck: true,
    skipRBAC: true,
    skipLoading: true
  }
};


